import { Card } from 'antd';
import { FolderOpenOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import './styles.css';

interface RegisterFinepCardProps {
    imageSrc: string;
    text: string;
    percentage: number;
    route: string;
}

export const RegisterFinepCard = ({ imageSrc, text, percentage, route }: RegisterFinepCardProps) => {
    return (
        <Link to={route} className="register-finep-card-link">
            <Card bordered={false} className="register-finep-card">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <img src={imageSrc} alt={text} className="register-finep-card-image" />
                    <div className="register-finep-card-text">
                        <FolderOpenOutlined className="register-finep-card-icon" />
                        <strong className="register-finep-card-title">{text}</strong>
                    </div>
                    <p className="register-finep-card-percentage">{percentage} % Validado</p>
                </div>
            </Card>
        </Link>
    );
};